export const soldierCourses = [
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
];

export const officerCourses = [
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
  'Introduction to LOAC',
];

export const mainPageLayoutByVariant = {
  desktop: {
    course: {
      subtitleVariant: 'MS-regular-s24-lh28',
      titleVariant: 'BN-bold-s43-lh38',
    },
    getStarted: {
      px: 156,
      subtitleVariant: 'MS-bold-s28-lh29',
      titleVariant: 'BN-bold-s160-lh125',
    },
    intro: {
      pb: 80,
      pt: 124,
      px: 156,
      titleVariant: 'BN-bold-s80-lh84',
    },
    pl: 156,
    pr: 156,
    px: 156,
    structure: {
      pb: 104,
      pt: 80,
      px: 156,
      titleVariant: 'BN-bold-s80-lh84',
    },
    title: {
      pt: 211,
      subtitleVariant: 'MS-regular-s32-lh50',
      titleVariant: 'BN-bold-s123-lh104',
    },
  },
  laptop: {
    course: {
      subtitleVariant: 'MS-regular-s24-lh28',
      titleVariant: 'BN-bold-s43-lh38',
    },
    getStarted: {
      px: 24,
      subtitleVariant: 'MS-bold-s28-lh29',
      titleVariant: 'BN-bold-s160-lh125',
    },
    intro: {
      pb: 80,
      pt: 124,
      px: 24,
      titleVariant: 'BN-bold-s80-lh84',
    },
    pl: 24,
    pr: 24,
    px: 24,
    structure: {
      pb: 104,
      pt: 80,
      px: 24,
      titleVariant: 'BN-bold-s80-lh84',
    },
    title: {
      pt: 193,
      subtitleVariant: 'MS-regular-s32-lh50',
      titleVariant: 'BN-bold-s88-lh75',
    },
  },
  mobile: {
    course: {
      subtitleVariant: 'MS-regular-s16-lh25',
      titleVariant: 'BN-bold-s40-lh35',
    },
    getStarted: {
      px: 24,
      subtitleVariant: 'MS-bold-s24-lh25',
      titleVariant: 'BN-bold-s64-lh64',
    },
    intro: {
      pb: 0,
      pt: 10,
      px: 12,
      titleVariant: 'BN-bold-s64-lh64',
    },
    pl: 24,
    pr: 24,
    px: 24,
    structure: {
      pb: 80,
      pt: 80,
      px: 16,
      titleVariant: 'BN-bold-s76-lh80',
    },
    title: {
      pt: 166,
      subtitleVariant: 'MS-regular-s16-lh25',
      titleVariant: 'BN-bold-s56-lh50',
    },
  },
  tablet: {
    course: {
      subtitleVariant: 'MS-regular-s24-lh28',
      titleVariant: 'BN-bold-s43-lh38',
    },
    getStarted: {
      px: 24,
      subtitleVariant: 'MS-bold-s28-lh29',
      titleVariant: 'BN-bold-s88-lh75',
    },
    intro: {
      pb: 80,
      pt: 124,
      px: 24,
      titleVariant: 'BN-bold-s80-lh84',
    },
    pl: 24,
    pr: 24,
    px: 24,
    structure: {
      pb: 104,
      pt: 80,
      px: 24,
      titleVariant: 'BN-bold-s80-lh84',
    },
    title: {
      pt: 193,
      subtitleVariant: 'MS-regular-s32-lh50',
      titleVariant: 'BN-bold-s56-lh50',
    },
  },
};
